import Select from "react-select";
import {customTheme} from "../../../../../IntReports/LocationTab";
import {useContext, useEffect} from "react";
import TechnicalEngagementContext from "../../TechnicalEngagementContext";
import {useQuery} from "react-query";
import apiService from "../../../../../../../api/apiService";
import {opportunitiesByAccountId} from "../../../../../../../utils/const/query-key";
import stepperContext from "../StepperContext";

const OpportunityDropdown = (props) => {
    const {opportunityValue,setOpportunityValue, setTechnicalEngagementValue,opportunitiesByIdData,customerName} = props;
    const { technicalEngagement,setTechnicalEngagement} = useContext(TechnicalEngagementContext);
    const { opportunity,setOpportunity} = useContext(stepperContext);


    const handleSelect = (val) => {
        setOpportunityValue(val);
        setOpportunity(val)
        setTechnicalEngagement(prevState => {
            return{
                ...prevState,
                opportunity: val.value
            }
        });
        setTechnicalEngagementValue({});
    }

  return(
              <Select
                  id={"opportunity_dropdown"}
                  placeholder={<div>Select Opportunity</div>}
                  options={opportunitiesByIdData?.map(opportunity => {
                      return {label: opportunity.name, value: opportunity.id}
                  })}
                  onChange={handleSelect}
                  theme={customTheme}
                  value={ opportunity  }
                  isDisabled={technicalEngagement?.accountName === "" || opportunitiesByIdData?.length === 0 || customerName === ""}
              />
  );

}
export default OpportunityDropdown;
